import { JSX } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { SerendieSymbol } from "@serendie/symbols";

export class TickSymbol extends BaseComponent<ITickSymbolProps, ITickSymbolState>
{
    public render(): JSX.Element
    {
        const { value } = this.props;

        return (
            <SerendieSymbol
                name={value ? 'check-circle' : 'close-circle'}
                color={value ? 'var(--colors-sd-reference-color-scale-green-600)' : 'var(--colors-sd-reference-color-scale-red-400)'}
                style={{ marginLeft: '32px' }}
            />
        );
    }
}

export interface ITickSymbolProps
{
    value: boolean;
}

export interface ITickSymbolState { }
